import { render } from "./Home.vue?vue&type=template&id=6534e4b3&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=6534e4b3&scoped=true&lang=css"

import exportComponent from "/Users/shussain/Development/Web/uk.co.abdulsbaltihouse/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6534e4b3"]])

export default __exports__